/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.LoginExtra";
        const PLACEHOLDER1 = "#loginExtraPlaceholder1";
        const PLACEHOLDER2 = "#loginExtraPlaceholder2";
        const PLACEHOLDER3 = "#loginExtraPlaceholder3";
        class LoginExtraWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("LoginExtraWidgetTypeClass.createInstance()");
                    return new LoginExtraWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("LoginExtraWidgetTypeClass._storeHtml()");
                    LoginExtraWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("LoginExtraWidgetTypeClass::constructor");
                this._allowedOnLogon = true;
                if (LoginExtraWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/LoginExtra/loginExtra.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.LoginExtraWidgetTypeClass = LoginExtraWidgetTypeClass;
        class LoginExtraWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._contentConfig = null;
                this._defaultTitle = null;
                this._text = null;
                this._link = null;
                this.presentInstance = () => {
                    this._log.info("LoginExtraWidgetInstanceClass.presentInstance()");
                    let presentInstance = false;
                    let config = this._config;
                    if (!config.hasOwnProperty('Content')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no content section in widget config");
                        }
                        let appConfig = this._core.Config.getApplicationConfig();
                        if (appConfig.hasOwnProperty('Content') && appConfig.Content) {
                            if (appConfig.Content.hasOwnProperty('LoginScreen') && appConfig.Content.LoginScreen) {
                                let loginScreen = appConfig.Content.LoginScreen;
                                if (loginScreen.hasOwnProperty('ShowExtras') && loginScreen.ShowExtras) {
                                    switch (config.PlaceHolder) {
                                        case PLACEHOLDER1:
                                            if (loginScreen.hasOwnProperty('Panel1') && loginScreen.Panel1) {
                                                presentInstance = true;
                                                this._defaultTitle = loginScreen.PanelHeading1;
                                                this._contentConfig = {};
                                                this._contentConfig.Text = loginScreen.PanelText1;
                                                this._contentConfig.Label = loginScreen.PanelButton1;
                                                this._contentConfig.Link = loginScreen.PanelLink1;
                                            }
                                            break;
                                        case PLACEHOLDER2:
                                            if (loginScreen.hasOwnProperty('Panel2') && loginScreen.Panel2) {
                                                presentInstance = true;
                                                this._defaultTitle = loginScreen.PanelHeading2;
                                                this._contentConfig = {};
                                                this._contentConfig.Text = loginScreen.PanelText2;
                                                this._contentConfig.Label = loginScreen.PanelButton2;
                                                this._contentConfig.Link = loginScreen.PanelLink2;
                                            }
                                            break;
                                        case PLACEHOLDER3:
                                            if (loginScreen.hasOwnProperty('Panel3') && loginScreen.Panel3) {
                                                presentInstance = true;
                                                this._defaultTitle = loginScreen.PanelHeading3;
                                                this._contentConfig = {};
                                                this._contentConfig.Text = loginScreen.PanelText3;
                                                this._contentConfig.Label = loginScreen.PanelButton3;
                                                this._contentConfig.Link = loginScreen.PanelLink3;
                                            }
                                            break;
                                        default:
                                            break;
                                    }
                                }
                            }
                        }
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("content section found in widget config");
                        }
                        presentInstance = true;
                        this._contentConfig = config.Content;
                    }
                    if (!presentInstance) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("widget instance for '" + config.PlaceHolder + "' is not enabled");
                        }
                        return;
                    }
                    this._container.innerHTML = LoginExtraWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    // get elements to hold
                    this._text = this._container.querySelector('#loginExtraText');
                    this._link = this._container.querySelector('#loginExtraLink');
                    this._widgets.setTitle(this._config, this._container.querySelector('#loginExtraHeading'), this._defaultTitle);
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    // Translations
                    this._core.Helper.setElementTranslation(this._text, this._contentConfig.Text);
                    this._core.Helper.setElementTranslation(this._link.querySelector('#loginExtraLinkLabel'), this._contentConfig.Label);
                    this._link.href = this._contentConfig.Link;
                    this._type.instanceReady(this.getHandle());
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("LoginExtraWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
        }
        LoginExtraWidgetInstanceClass.HtmlData = null;
        Widgets.LoginExtraWidgetInstanceClass = LoginExtraWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
